// ── LO QUE SE LE DICE CUANDO EL SERVIDOR DICE QUE NO ────────────────────────
//  Dos cosas que se rompían en las pantallas de entrar y de crear cuenta
//  (22-09-2026):
//
//  · El freno por intentos. Tras varios envíos seguidos el servidor contesta
//    429 —y ese cuerpo no trae `detail`—, así que la pantalla pintaba «Email o
//    contraseña incorrectos». La persona volvía a escribir su contraseña buena
//    una y otra vez sin entender por qué no entraba.
//  · Un `detail` que no es texto. Cuando el servidor rechaza por validación,
//    `detail` es una LISTA de objetos; meterla en el JSX rompe la pantalla
//    entera y deja al alumno mirando un cuadro en blanco.
export function mensajeDeError(respuesta, detalle, porDefecto) {
    if (respuesta && respuesta.status === 429) {
        return typeof detalle === 'string' && detalle
            ? detalle
            : 'Demasiados intentos seguidos. Espera un minuto y vuelve a intentarlo.';
    }
    if (typeof detalle === 'string' && detalle) return detalle;
    if (detalle && typeof detalle === 'object') {
        if (typeof detalle.message === 'string') return detalle.message;
        if (Array.isArray(detalle)) {
            const primero = detalle.find((d) => d && typeof d.msg === 'string');
            if (primero) return primero.msg;
        }
    }
    return porDefecto;
}
